/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Guid } from 'guid-typescript';
import { toast } from 'react-toastify';
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup
} from '@mui/material';

import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import Button from '@/main/components/shared/button/button';
import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import KogModalComponent from '@/main/components/modal/ModalComponent';
import BusinessHoursModal, {
  defaultValuePeriodBusiness,
  IPeriodBusinessInfoState
} from '@/main/components/shared/businessHoursModal/businessHoursModal';
import AddressInfo, {
  IAddressInfoState
} from '@/main/components/shared/addressInfo';
import ContactInfo, {
  formattedContactGet,
  formattedContactSave,
  IContactInfoState
} from '@/main/components/shared/contactInfo';
import { bodyshopApi, companyBusinessHourApi } from '@/main/api';
import { ReasonFilterRequest } from '@/main/models/request/reasonRequest';
import { DistributionRegionFilterRequest } from '@/main/models/request/distributionRegionRequest';
import { BodyShopSaveRequest } from '@/main/models/request/bodyshopRequest';
import { ManufacturerRequest } from '@/main/models/request/vehicleRequest';
import {
  getTranslateByKey,
  isNullUndefined,
  isShowControlByElementId,
  removeEmptyValues
} from '@/main/services/utils';
import { ReasonTypeEnum } from '@/main/services/enum/ReasonEnum';
import useAsyncModalConfirmReason from '@/main/components/shared/asyncModalConfirmReason/asyncModalConfirmReason';
import { toBase64 } from '@/main/services/utilsFile';
import {
  getSupplierType,
} from '@/main/store/supplierType';
import {
  getManufacturers,
} from '@/main/store/vehicle/manufacturer';
import { getReason } from '@/main/store/reason';
import {
  getDistributionRegion,
} from '@/main/store/distributionRegion';
import { TabSettingRegister } from '@/main/components/shared/tabs/bodyshop/tabSettingRegister/tabSettingRegister';

import { KogTabsComponent } from '@/main/components/shared/tabs/tabs';
import { ParameterTypesResponse } from '@/main/models/response/parameterTypesResponse';
import SectionInfo from './sectionInfo';
import InsurerInfo from './insurerInfo';
import BranchInfo from './branchInfo';
import {
  BodyshopRegisterProvider,
  IBodyShopRegisterForm,
  ITypeCompany,
  useBodyshopRegisterContext
} from './context';
import * as S from './styles';
import { formatDateToISOString } from '@/main/services/utilsDate';
import { Controls } from '@/main/services/constants/constantsControl';
import { CustomError } from '@/main/services/class/customError';
import { resetReducerBodyshops } from '@/main/store/bodyshop';
import { PrioritySuppliersResponse } from '@/main/models/response/PrioritySuppliersResponse';
import { PartTypePerPartResponse } from '@/main/models/response/partTypePerPartResponse';
import { KOGAreaButtons } from '@/main/components/shared/styles';
import { SaveSupplierCompanyRelationRequest } from '@/main/models/request';
import CompanyManufacturer from '@/main/components/shared/companyManufacturer/companyManufacturer';
import TabClaimSettings from './tabBodyshopClaimSettings';
import { BusinessHourResponse } from '@/main/models/response';
import KogModalSideComponent from '@/main/components/modal/ModalSide';
import { parse as dateParse } from 'date-fns';
import BusinessHoursGrid from '@/main/components/shared/businessHoursGrid/businessHoursGrid';
import lodash from 'lodash';
import { CompanyTypeEnum } from '@/main/services/enum/CompanyTypeEnum';
import CompanyHistorical from '@/main/components/shared/companyHistorical/companyHistorical';

function BodyShopRegisterScreen() {
  const INTIAL_TAB_GENERAL_INFO: number = 0;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const methods = useFormContext<IBodyShopRegisterForm>();
  const [searchParams, setSearchParams] = useSearchParams();
  const guidBodyshopParams = searchParams.get('bodyShopGuid');
  const {
    hasScreenBranch,
    isEdit,
    isLoadingSave,
    typeCompany,
    setIsLoadingSave,
    setIsEdit,
    changeTypeCompany,
    displaySaveBranchWithHeadquarter,
    displayEditBranchWithHeadquarter,
    displayEditHeadquarter,
    displayEditBranch
  } = useBodyshopRegisterContext();

  const [isLoadingInfo, setIsLoadingInfo] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState(false);
  const [getConfirmationReason, ModalConfirmationReason] = useAsyncModalConfirmReason();

  const [dataContacts, setDataContacts] = useState<IContactInfoState[]>([]);
  const [dataAddress, setDataAddress] = useState<IAddressInfoState[]>([]);
  const [dataPeriodBusiness, setDataPeriodBusiness] = useState<IPeriodBusinessInfoState[]>(defaultValuePeriodBusiness());
  const [dataUserPeriodBusiness, setDataUserPeriodBusiness] = useState<BusinessHourResponse[]>(dataPeriodBusiness);
  const [dataPrioritySuppliers, setDataPrioritySuppliers] = useState<PrioritySuppliersResponse[]>([]);
  const [dataPartTypePerPart, setDataPartTypePerPart] = useState<PartTypePerPartResponse[]>([]);
  const [dataPurchaseCriteria, setDataPurchaseCriteria] = useState<any[]>([]);
  const [renderModal, setRenderModal] = useState<React.ReactNode>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [
    blacklistAndMySuppliersDeleteItem,
    setBlacklistAndMySuppliersDeleteItem
  ] = useState<SaveSupplierCompanyRelationRequest[]>([]);

  //edit business hour states
  const [hasEditBusinessHour, setHasEditBusinessHour] = useState(false);
  const [deletePeriodBusiness, setDeletePeriodBusiness] = useState<string[]>([]);
  const [businessHourEdit, setBusinessHourEdit] = useState<IPeriodBusinessInfoState | null>(null);

  const watcherCompany = methods.watch('companyNameHeadquarter');
  const watcherCountry = methods.watch('country');

  const [dataParameterTypes, setDataParameterTypes] = useState<ParameterTypesResponse[]>([]);
  const [guidCompany, setGuidCompany] = useState<string>();

  const rowHeadersPeriodBusiness = [
    getTranslateByKey('information.initialHour'),
    getTranslateByKey('information.finalHour'),
    getTranslateByKey('information.description'),
    <div style={{ textAlign: 'center' }}>
      {getTranslateByKey('information.actions')}
    </div>
  ];

  useEffect(() => {
    return () => {
      dispatch(resetReducerBodyshops());
    };
  }, []);
  useEffect(() => {
    if (!isNullUndefined(watcherCountry)) {
      dispatch(getSupplierType());

      const requestMake: ManufacturerRequest = {
        guidCountry: String(watcherCountry.key)
      };
      dispatch(getManufacturers(requestMake));

      const requestRegion: DistributionRegionFilterRequest = {
        guidCountry: String(watcherCountry.key)
      };
      dispatch(getDistributionRegion(requestRegion));

      const requestReason: ReasonFilterRequest = {
        guidCountry: String(watcherCountry.key),
        idReasonType: ReasonTypeEnum.Blacklist
      };
      dispatch(getReason(requestReason));
    }
  }, [watcherCountry?.key]);

  useEffect(() => {
    if (hasEditBusinessHour && businessHourEdit) {
      openBusinessHoursModal();
    }
  }, [hasEditBusinessHour, businessHourEdit]);

  useEffect(() => {
    setDataUserPeriodBusiness(dataPeriodBusiness);
  }, [dataPeriodBusiness]);

  // FUNCTION TO FORMAT DATA

  const formatDataAddress = (
    addresses: IAddressInfoState[],
    isEditAddress = false
  ) => {
    return addresses.map(address => ({
      ...(isEditAddress && {
        guid: Guid.isGuid(address.id) ? address.id : Guid.EMPTY
      }),
      idAddressType: address.addressType.key,
      street: address.address,
      complement: address.complement,
      number: address.number,
      delivery: address.isDeliveryAddress,
      municipality: {
        guid: address.municipality.key
      }
    }));
  };

  function validateForm() {
    const messages = [];

    if (dataContacts.length === 0)
      messages.push(
        getTranslateByKey('information.mustHaveAtLeastOneContact', true)
      );
    if (dataAddress.length === 0)
      messages.push(
        getTranslateByKey('information.mustHaveAtLeastOneAddress', true)
      );

    if (dataContacts.length > 0) {
      const primaryContact = dataContacts.find(
        contact => contact.isPrimaryContact
      );
      if (!primaryContact)
        messages.push(
          getTranslateByKey(
            'information.mustHaveAtLeastOnePrimaryContact',
            true
          )
        );
    }
    if (dataAddress.length > 0) {
      const primaryAddress = dataAddress.find(
        address => address.isDeliveryAddress
      );
      if (!primaryAddress)
        messages.push(
          getTranslateByKey(
            'information.mustHaveAtLeastOneDeliveryAddress',
            true
          )
        );
    }
    if (messages.length > 0) {
      messages.map(message => toast.error(message));
      throw new CustomError(messages.join('/n'), 'MISSING_FIELDS');
    }
  }

  // Handle Functions
  async function handleSubmitRegisterBodyshop(data: IBodyShopRegisterForm) {
    try {
      setIsLoadingSave(true);
      validateForm();

      await saveBusinessHours();

      const formattedContacts = formattedContactSave(dataContacts);
      const formattedAddress = formatDataAddress(dataAddress);

      const requestData: BodyShopSaveRequest = removeEmptyValues({
        guidCountry: String(data?.country?.key),
        idStatusRegister: Number(data?.status?.key),
        companyName: data.companyName,
        registrationNumber: data.rfc,
        tradeName: data.tradeName,
        contacts: formattedContacts,
        addresses: formattedAddress,
        guidHeadquarter: data.companyNameHeadquarter?.key,
        newBranch: typeCompany === 'branch',
        guidBodyshopType: String(data.bodyshopType?.key),
        idEntityType: Number(data.entityType?.enumValue),
        observation: data.observation
      } as BodyShopSaveRequest);

      const response = await bodyshopApi.saveBodyshop(requestData);
      if (typeCompany === 'headquarters') {
        toast.success(
          getTranslateByKey('information.bodyshopSavedSuccessfully')
        );
        setOpenModal(true);
        setSearchParams(
          { bodyShopGuid: response.data.result.guid },
          { replace: true }
        );
      } else {
        toast.success(
          getTranslateByKey('information.bodyshopBranchSavedSuccessfully')
        );
        setIsEdit(true);
        displayEditBranch();
        setSearchParams(
          { bodyShopGuid: response.data.result.guid },
          { replace: true }
        );
      }
    } catch (error) {
      // eslint-disable-next-line no-empty
      if (error instanceof CustomError) {
      }
    } finally {
      setIsLoadingSave(false);
    }
  }

  async function handleSubmitEditBodyshop(data: IBodyShopRegisterForm) {
    try {
      validateForm();
      const formattedContacts = formattedContactSave(dataContacts, true);
      const formattedAddress = formatDataAddress(dataAddress, true);

      let resultConfirm = null;
      let filesRequest = undefined;

      resultConfirm = await getConfirmationReason(
        getTranslateByKey('information.confirmChangeTitle'),
        ReasonTypeEnum.ChangeCompany
      );

      if (!resultConfirm.confirmed) return;

      if (resultConfirm.files && resultConfirm.files.length > 0) {
        filesRequest = await Promise.all(
          resultConfirm.files.map(async item => {
            const base64DataUrl = await toBase64(item);
            return {
              fileName: item.name,
              contentType: item.type,
              fileBase64: base64DataUrl as string
            };
          })
        );
      }

      setIsLoadingSave(true);

      const changeJustification = {
        guidReason: resultConfirm?.reason ? String(resultConfirm.reason.key) : null,
        reasonDescription: resultConfirm?.observation || null,
        filesUpload: filesRequest
      };

      await saveBusinessHours(changeJustification);

      const requestData: BodyShopSaveRequest = removeEmptyValues({
        guidCountry: String(data?.country?.key),
        idStatusRegister: Number(data?.status?.key),
        companyName: data.companyName,
        registrationNumber: data.rfc,
        tradeName: data.tradeName,
        contacts: formattedContacts,
        addresses: formattedAddress,
        guidHeadquarter: data.companyNameHeadquarter?.key,
        guid: guidBodyshopParams,
        newBranch: false,
        supplierCompanyRelations: blacklistAndMySuppliersDeleteItem,
        guidBodyshopType: String(data.bodyshopType?.key),
        idEntityType: Number(data.entityType?.enumValue),
        observation: data.observation,
        changeJustification: changeJustification
      } as BodyShopSaveRequest);

      await bodyshopApi.saveBodyshop(requestData);

      if (typeCompany === 'headquarters') {
        toast.success(
          getTranslateByKey('information.bodyshopEditSuccessfully')
        );
      } else {
        toast.success(
          getTranslateByKey('information.bodyshopBranchEditSuccessfully')
        );
      }

      if (guidBodyshopParams) {
        loadInfoBodyshop(guidBodyshopParams);
      }
    } finally {
      setIsLoadingSave(false);
    }
  }

  async function saveBusinessHours(changeJustification?: any) {
    if (deletePeriodBusiness.length !== 0) {
      const filteredData = dataUserPeriodBusiness.filter(
        item => !item.guid || !deletePeriodBusiness.includes(item.guid)
      );

      const formattedPeriodBusiness = formatDataPeriodBusiness(filteredData).map(item => {
        if (!!guidBodyshopParams) {
          item.guidBodyshop = guidBodyshopParams;
        }
        return item;
      });

      const deleteAllPeriodBusiness = [
        {
          deletePeriodBusiness,
          guidBodyshop: guidBodyshopParams,
          startDate: '',
          endDate: '',
          description: ''
        }
      ];

      const requestPeriodBusiness =
        formattedPeriodBusiness.length !== 0
          ? formattedPeriodBusiness
          : deleteAllPeriodBusiness;

      const payload = {
        companyBusinessHours: requestPeriodBusiness as any,
        changeJustification: changeJustification
      };

      try {
        const res = await companyBusinessHourApi.deleteBusinessHour(payload);
        toast.success(
          getTranslateByKey('businessHour.businessHourSavedSuccessfully')
        );
        const data = res.data.result;
        const convertedInitialhour = convertStringToHour(
          data.initialHour,
          data?.initialHourType?.key
        );
        const convertedFinalHour = convertStringToHour(
          data.finalHour,
          data?.finalHourType?.key
        );

        const intitialHourFormatted = new Date();
        intitialHourFormatted.setHours(
          convertedInitialhour.getHours(),
          convertedInitialhour.getMinutes()
        );

        const finalHourFormatted = new Date();
        finalHourFormatted.setHours(
          convertedFinalHour.getHours(),
          convertedFinalHour.getMinutes()
        );
        setDataUserPeriodBusiness(prevState => {
          const clonePrevState = lodash.cloneDeep(prevState);
          const index = prevState.findIndex(item => item.id === data.id);
          clonePrevState[index] = {
            ...data,
            id: data.id,
            guid: data.guid,
            initialHour: intitialHourFormatted,
            finalHour: finalHourFormatted
          } as IPeriodBusinessInfoState;

          return [...clonePrevState];
        });
        setDeletePeriodBusiness([]);
      } catch (error) {
        // Handle error if needed
      }
    }
  }

  async function handleSaveAll(data: IBodyShopRegisterForm) {
    try {
      if (isEdit) {
        await handleSubmitEditBodyshop(data);
      } else {
        await handleSubmitRegisterBodyshop(data);
      }
    } catch (error) {
      console.error('Erro ao salvar dados:', error);
    }
  }

  function handleDeleteBusinessHourInfo(id: string) {
    setHasEditBusinessHour(false);
    setDataUserPeriodBusiness(prevState => {
      const index = prevState.findIndex(item => item.id === id);
      setDeletePeriodBusiness(prev => [...prev, id]);
      prevState.splice(index, 1);
      return [...prevState];
    });
  }

  function handleEditBusinessHoursInfo(businessHour: IPeriodBusinessInfoState) {
    setBusinessHourEdit(businessHour);
    setHasEditBusinessHour(true);
  }

  const convertStringToHour = (hour: string, type: string) => {
    const hourString = `${hour} ${type}`;
    const convertedDate = dateParse(hourString, 'hh:mm a', new Date());
    return convertedDate;
  };

  const formatDataPeriodBusiness = (
    periodBusiness: IPeriodBusinessInfoState[]
  ) => {
    return periodBusiness.map(period =>
      removeEmptyValues({
        id: period.id,
        guid: period.guid,
        guidBodyshop: period.guidBodyShop,
        startDate: formatDateToISOString(period.initialHour),
        endDate: formatDateToISOString(period.finalHour),
        description: period.description
      })
    );
  };


  function loadInfoBodyshop(guidBodyshopRequest: string) {
    setIsEdit(true);
    setIsLoadingInfo(true);

    bodyshopApi
      .getRegistrationDataBodyshop({ guidBodyShop: guidBodyshopRequest })
      .then(response => {
        const resultData = response.data.result;

        // Set option type company
        if (
          resultData.guidHeadQuarter !== undefined &&
          resultData.guidHeadQuarter !== '00000000-0000-0000-0000-000000000000'
        ) {
          displayEditBranchWithHeadquarter(
            resultData.country.guid,
            resultData?.guidHeadQuarter
          );
        } else {
          displayEditHeadquarter();
        }

        // Set Form values
        methods.setValue('country', {
          key: resultData.country.guid,
          value: resultData.country.name
        });
        methods.setValue('companyName', resultData.companyName);
        methods.setValue('rfc', resultData.registrationNumber);
        methods.setValue('observation', resultData.observation);
        methods.setValue('status', {
          key: resultData.statusRegister.idStatusRegister,
          value: resultData.statusRegister.name
        });
        methods.setValue('tradeName', resultData.tradeName);
        methods.setValue('bodyshopType', {
          key: resultData.bodyshopType.guid,
          value: resultData.bodyshopType.name
        });

        if (resultData.entityType) {
          methods.setValue('entityType', {
            key: resultData.entityType.name,
            enumValue: resultData.entityType.idEntityType,
            value: resultData.entityType.name
          });
        }

        // SET state values

        const formattedContacts = resultData.contacts.map(contact =>
          formattedContactGet(contact)
        );

        const formattedAddress = resultData.addresses.map(address => ({
          id: address.guid,
          address: address.street,
          complement: address.complement,
          number: address.number === '' ? null : address.number,
          zipCode: address.municipality.zipCode,
          isDeliveryAddress: String(address.delivery).toLowerCase() === 'true', // check this field
          addressType: {
            key: address.addressType.idAddressType,
            value: address.addressType.name
          },
          city: {
            key: address.municipality.city.guid,
            value: address.municipality.city.name
          },
          municipality: {
            key: address.municipality.guid,
            value: address.municipality.name
          },
          state: {
            key: address.municipality.city.state.guid,
            value: address.municipality.city.state.name
          }
        })) as IAddressInfoState[];
        const formattedPeriodBusiness: IPeriodBusinessInfoState[] = resultData.businessHours.map(
          period => ({
            id: period.id,
            guid: period.guid,
            initialHour: new Date(period.startDate),
            finalHour: new Date(period.endDate),
            description: period.description
          })
        );
        setDataParameterTypes(resultData.parameterTypes);
        setDataContacts(formattedContacts);
        setDataAddress(formattedAddress);
        setDataPurchaseCriteria(resultData.purchaseCriteria);
        setDataPrioritySuppliers(resultData.prioritySuppliers);
        setDataPartTypePerPart(resultData.partTypePerParts);
        setDataPeriodBusiness(formattedPeriodBusiness);
        setGuidCompany(resultData.guidCompany);
      })
      .catch(() => { })
      .finally(() => {
        setIsLoadingInfo(false);
      });
  }

  function handleBack() {
    navigate(-1);
  }

  function clearAddBranch() {
    setDataContacts([]);
    setDataAddress([]);
  }

  function openBusinessHoursModal() {
    setRenderModal(
      <BusinessHoursModal
        guidBodyShop={guidBodyshopParams}
        hasEdit={hasEditBusinessHour}
        setHasEdit={setHasEditBusinessHour}
        businessHourEdit={businessHourEdit}
        dataPeriodBusiness={dataUserPeriodBusiness}
        setDataPeriodBusiness={setDataUserPeriodBusiness}
        setOpen={setOpen}
      />
    );
    setOpen(true);
  }

  function closeBusinessHoursModal() {
    setBusinessHourEdit(null);
    setHasEditBusinessHour(false);
    setRenderModal([]);
    setOpen(false);
  }

  useEffect(() => {
    if (guidBodyshopParams) {
      setIsEdit(true);
      setIsLoadingInfo(true);
      loadInfoBodyshop(guidBodyshopParams);
    }
  }, [guidBodyshopParams]);



  if (isLoadingInfo) {
    return <LoadingComponent />;
  }
  function GeneralInfo() {
    return (
      <S.Container>
        <FormControl component="fieldset">
          <RadioGroup
            value={typeCompany}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              changeTypeCompany(e.currentTarget.value as ITypeCompany)
            }
            style={{ flexDirection: 'row' }}>
            {!hasScreenBranch && (
              <FormControlLabel
                value="headquarters"
                control={<Radio id="id-registerBodyshop-radio-headquarters" />}
                label={getTranslateByKey('information.headquarters')}
              />
            )}
            {(!isEdit || hasScreenBranch) && (
              <FormControlLabel
                value="branch"
                control={<Radio id="id-registerBodyshop-radio-branch" />}
                label={getTranslateByKey('information.branch')}
              />
            )}
          </RadioGroup>
        </FormControl>

        <SectionInfo />
        <ContactInfo
          dataContacts={dataContacts}
          setDataContacts={setDataContacts}
          typeCompany={typeCompany}
          watcherCompany={watcherCompany}
          watcherCountry={watcherCountry}
          companyType={CompanyTypeEnum.BodyShop}
          companyName={methods.watch('companyName')}
        />
        <AddressInfo
          dataAddress={dataAddress}
          setDataAddress={setDataAddress}
          typeCompany={typeCompany}
          watcherCompany={watcherCompany}
          watcherCountry={watcherCountry}
        />
        {isEdit && typeCompany === 'headquarters' && (
          <BranchInfo
            guidBodyshopEdit={guidBodyshopParams}
            clearAddBranch={() => clearAddBranch()}
            loadInfoBodyshop={loadInfoBodyshop}
          />
        )}
        {isEdit && (
          <React.Fragment>
            <CompanyManufacturer
              guidCompany={guidCompany}
              watcherCountry={watcherCountry}
            />
            <InsurerInfo guidBodyshopEdit={guidBodyshopParams} />

            <S.ContainerSection>
              <BusinessHoursGrid
                rowHeaders={rowHeadersPeriodBusiness}
                dataPeriodBusiness={dataUserPeriodBusiness}
                handleEditBusinessHoursInfo={handleEditBusinessHoursInfo}
                handleDeleteBusinessHourInfo={handleDeleteBusinessHourInfo}
                openModal={openBusinessHoursModal}
              />
            </S.ContainerSection>
          </React.Fragment>
        )}


        <KOGAreaButtons $isRegisterScreen>
          <SecondaryButton
            id="id-registerBodyshop-btn-back"
            type="button"
            disabled={isLoadingSave}
            onClick={handleBack}>
            {getTranslateByKey('information.back')}
          </SecondaryButton>
          <Button
            id="id-registerBodyshop-btn-save"
            type="submit"
            isLoading={isLoadingSave}
            onClick={methods.handleSubmit(handleSaveAll)}>
            {getTranslateByKey('information.save')}
          </Button>
        </KOGAreaButtons>
        {openModal && (
          <KogModalComponent
            open={openModal}
            handleClose={() => setOpenModal(false)}
            title={getTranslateByKey('information.addNewBranch')}
            content={getTranslateByKey('information.addBranchInBodyshop')}
            hasActionCancel={true}
            hasActionConfirm={true}
            labelActionCancel={getTranslateByKey('information.no')}
            labelActionConfirm={getTranslateByKey('information.yes')}
            onClickActionCancel={() => {
              setIsEdit(true);
              displayEditHeadquarter();
            }}
            onClickActionConfirm={() => {
              const countryForm = methods.getValues('country')?.key;
              const rfcForm = methods.getValues('rfc');
              methods.reset();
              clearAddBranch();
              searchParams.delete('bodyShopGuid');
              setSearchParams(searchParams, { replace: true });
              displaySaveBranchWithHeadquarter(String(countryForm), rfcForm);
            }}
          />
        )}
      </S.Container>
    );
  }

  const bodyShopFormData = methods.getValues();
  const tabPanels = [
    {
      tab: getTranslateByKey('control.tabGeneralInfo'),
      panel: GeneralInfo(),
      isShowControl: true
    },
    {
      tab: getTranslateByKey('control.tabPartSettings'),
      panel: (
        <TabSettingRegister
          guidBodyshop={guidBodyshopParams}
          guidCountry={!!watcherCountry ? String(watcherCountry) : null}
          guidInsurer={null}
          dataParameterTypes={dataParameterTypes}
          setDataParameterTypes={setDataParameterTypes}
          purchaseCriteria={dataPurchaseCriteria}
          prioritySuppliers={dataPrioritySuppliers}
          partTypePerPart={dataPartTypePerPart}
          onSubmitBodyShopEdit={handleSubmitEditBodyshop}
          bodyShopFormData={bodyShopFormData}
          blacklistAndMySuppliersDeleteItem={blacklistAndMySuppliersDeleteItem}
          setBlacklistAndMySuppliersDeleteItem={setBlacklistAndMySuppliersDeleteItem}
        />
      ),
      isShowControl: isEdit && isShowControlByElementId(Controls.IdTabSettings)
    },
    {
      tab: getTranslateByKey('control.tabClaimSettings'),
      panel: (
        <TabClaimSettings
          guidCompany={guidCompany}
          guidBodyShop={guidBodyshopParams}
        />
      ),
      isShowControl:
        isEdit && isShowControlByElementId(Controls.IdClaimConfigurations)
    },
    {
      tab: getTranslateByKey('control.historical'),
      panel: <CompanyHistorical guidCompany={guidCompany} />,
      isShowControl: isEdit && isShowControlByElementId(Controls.IdCompanyHistoricalBodyshop)
    }
  ];

  return (
    <ContainerScreen
      title={`
      ${getTranslateByKey('information.registration')}
      ${' > '}
      ${getTranslateByKey('information.registerBodyshop')}`}>
      <KogTabsComponent
        tabPanels={tabPanels}
        tabCurrent={INTIAL_TAB_GENERAL_INFO}
        onChangeTab={() => { }}
      />
      <KogModalSideComponent open={open} closeModal={() => closeBusinessHoursModal()}>
        {renderModal || ''}
      </KogModalSideComponent>
      <ModalConfirmationReason closeByOverlay={false} />
    </ContainerScreen>
  );
}

export default function BodyShopRegisterScreenLoaded() {
  return (
    <BodyshopRegisterProvider>
      <BodyShopRegisterScreen />
    </BodyshopRegisterProvider>
  );
}
